module.exports = __webpack_public_path__ + "static/how-to-fail-at-almost-everything-and-still-win-big-d9b2799c33faf7651a0f3709c41f7139.jpg";